import styled from 'styled-components';
import ReactPaginate from 'react-paginate';

export const ScrollWrapper = styled.div`
width: 100%;
`;

export const Table = styled.table`
width: 100%;
border-radius: 10px;
padding: 10px;
table-layout: fixed;
`;

export const TableHead = styled.thead`
display: flex;
flex-direction: column;

@media screen and (max-width: 768px){
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
}
`;

export const TableBody = styled.tbody`
display: flex;
flex-direction: column;

@media screen and (max-width: 768px){
  display: flex;
}
`;

export const Row = styled.tr`
display: flex;
width: 100%;
border-bottom: 2px solid #F0F0F0;
background: ${({ dark }) => (dark ? '#F0F0F0' : '')};
border-radius: 10px;

@media screen and (max-width: 768px) {
    border-bottom: 3px solid #ddd;
    display: block;
    margin-bottom: .625em;
}
`;

export const NormalTableHeader = styled.th`
width: 100%;
min-width: 500px;
display: flex;
padding: 10px;
letter-spacing: 0.5px;

@media screen and (max-width: 768px) {
    width: 100%;
    min-width: none;
}
`;

export const MediumTableHeader = styled.th`
width: 100%;
min-width: 200px;
display: flex;
padding: 10px;
letter-spacing: 0.5px;

@media screen and (max-width: 768px) {
    width: 100%;
    min-width: none;
}
`;

export const SmallTableHeader = styled.th`
width: 100%;
min-width: 80px;
max-width: 80px;
display: flex;
padding: 10px;
justify-content: center;
align-items: center;
letter-spacing: 0.5px;

@media screen and (max-width: 768px) {
    width: 100%;
    min-width: none;
    max-width: none;
}
`;

export const NormalTableCell = styled.td`
width: 100%;
min-width: 500px;
display: flex;
padding: 10px;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;

@media screen and (max-width: 768px) {
    border-bottom: 1px solid #ddd;
    display: block;
    font-size: .8em;
    text-align: right;
    width: 100%;
    min-width: auto;
    font-size: 11px;

    &:before {
    content: attr(data-label);
    float: left;
    font-weight: bold;
    text-transform: uppercase;
}}
`;

export const MediumTableCell = styled.td`
width: 100%;
min-width: 200px;
max-width: 200px;
display: flex;
padding: 10px;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;

@media screen and (max-width: 768px) {
    border-bottom: 1px solid #ddd;
    display: block;
    font-size: .8em;
    text-align: right;
    width: 100%;
    min-width: none;
    max-width: none;

    &:before {
    content: attr(data-label);
    float: left;
    font-weight: bold;
    text-transform: uppercase;
}}
`;

export const SmallTableCell = styled.td`
width: 100%;
min-width: 80px;
max-width: 80px;
display: flex;
padding: 10px;
justify-content: center;
align-items: center;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;

@media screen and (max-width: 768px) {
    border-bottom: 1px solid #ddd;
    display: block;
    font-size: .8em;
    text-align: right;
    width: 100%;
    min-width: none;
    max-width: none;

    &:before {
    content: attr(data-label);
    float: left;
    font-weight: bold;
    text-transform: uppercase;
    }
}
`;

export const Icon = styled.button`
display: flex;
align-items: center;
font-size: 20px;
width: fit-content;
height: fit-content;
background: none;
border: none;

&:hover {
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    transform: scale(1.05);
    color: ${({ edit }) => (edit ? 'green' : 'red')};
}
`;

export const IconWrapper = styled.div`
display: flex;
flex-direction: row;
gap: 10px;
`;

export const PaginateButton = styled.button`
display: flex;
width: fit-content;
height: fit-content;
padding: 5px;
background: linear-gradient(215deg, rgba(51,104,44,1) 0%, rgba(97,150,87,1) 100%);
color: #fff;
border-radius: 5px;
border: none;
justify-content: center;
align-items: center;
font-size: 20px;

&:hover {
    transition: all 0.2s ease-in-out;
    transform: scale(1.05);
    background: linear-gradient(45deg, rgba(51,104,44,1) 0%, rgba(97,150,87,1) 100%);
    cursor: pointer;
}
`;

export const MyPaginate = styled(ReactPaginate).attrs({
  // You can redifine classes here, if you want.
  activeClassName: 'active', // default to "disabled"
})`
    margin-bottom: 1rem;
    margin-top: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    list-style-type: none;
    margin-left: auto;
    margin-right: auto;
    li {
      padding: 3px;
    }
    li a {
      border-radius: 7px;
      padding: 0.1rem 1rem;
      border: gray 1px solid;
      cursor: pointer;
    }
    li.previous a,
    li.next a,
    li.break a {
      border-color: transparent;
    }
    li.active a {
      background-color: #33682c;
      border-color: transparent;
      color: white;
      min-width: 32px;
    }
    li.disabled a {
      color: grey;
    }
    li.disable,
    li.disabled a {
      cursor: default;
    }
  `;
